import AudioVolumeIndicator from './AudioVolumeIndicator'
import SpeakerVolumeIndicator from './SpeakerVolumeIndicator'

export default {
  AudioVolumeIndicator,
  SpeakerVolumeIndicator,
}
